<script setup lang="ts">
import {
  ProductParentType,
  ProductTagSize,
} from '@/types/components/product-card.types'

type Props = {
  type: ProductParentType
  size?: ProductTagSize
  color: string
  backgroundColor: string
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
})

const componentClasses = [
  'product-tag',
  `product-tag--type-${props.type}`,
  `product-tag--size-${props.size}`,
]

const componentStyles = {
  color: props.color || 'var(--ui-white)',
  background: props.backgroundColor || 'var(--ui-violet)',
}
</script>

<template>
  <div :class="componentClasses" :style="componentStyles">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
.product-tag {
  display: flex;
  gap: 2px;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  border-radius: 50px;
}

.product-tag--size-sm {
  padding: 2px 4px;

  @include media('>=desktop-mini') {
    padding: 2px 8px;
  }
}

.product-tag--size-md {
  padding: 4px 8px;
}

.product-tag--type-card {
  font-size: 8px;
  font-weight: 700;
  line-height: 10px;

  @include media('>=desktop-mini') {
    font-size: 12px;
    font-weight: 800;
    line-height: 16px;
  }
}

.product-tag--type-detail {
  font-size: 12px;
  font-weight: 800;
  line-height: 16px;
}
</style>
